import {
    Col, Row,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import HeaderIntroText from '../HeaderIntroText';

const NoRequests = () => (
    <>
        {/* <Row className='mb-3'>
            <Col className='d-block d-md-flex justify-content-between'>
                <h2 className='mb-3'>Manage requests</h2>
            </Col>
        </Row> */}
        <Row className='mb-3'>
            <Col>
                <HeaderIntroText>
                    {'You currently have no requests, please adjust your search filter options or create a '}
                    <Link
                        data-testid='new-request-link'
                        to='/services-we-offer'
                    >
                        new request
                    </Link>
                    .
                </HeaderIntroText>
                {/* <div className='d-grid mb-5 d-md-block'>
                    <Link
                        data-testid='new-request-button'
                        to='/services-we-offer'
                        className='btn btn-primary'
                    >
                        New request
                    </Link>
                </div> */}
            </Col>
        </Row>
    </>
);

export default NoRequests;
